"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const BasicNode_1 = require("./BasicNode");
const validations_1 = require("../validations");
class WorkflowReportNode extends BasicNode_1.BasicNode {
  constructor(props) {
    if (!props) props = { type: types_1.NODE_TYPES.WORKFLOW_REPORT };
    if (props.type !== types_1.NODE_TYPES.WORKFLOW_REPORT)
      throw new Error("Invalid Node type");
    super(props);
  }
  deserialize(data) {
    let nodeData = data || this.getNodeData();
    let deserializeData = {
      categories: [],
      type: types_1.NotificationType.EMAIL,
      slackConfig: "",
      notifyEmail: ""
    };
    if (!nodeData) return deserializeData;
    deserializeData = {
      tabName: nodeData.tabName,
      categories: nodeData.categories,
      type: nodeData.transport.type,
      slackConfig: nodeData.transport.options.slackConfig || "",
      notifyEmail: nodeData.transport.options.notifyEmail || ""
    };
    return deserializeData;
  }
  serialize(uiData) {
    let nodeData = {
      tabName: uiData.tabName,
      categories: uiData.categories,
      transport: {
        type: uiData.type,
        options: {
          slackConfig: uiData.slackConfig || "",
          notifyEmail: uiData.notifyEmail || ""
        }
      }
    };
    return nodeData;
  }
  validate() {
    return new validations_1.WorkflowReportNodeValidation().validate(this);
  }
  setId(props) {
    this.setBasicNodeId(props);
  }
}
exports.WorkflowReportNode = WorkflowReportNode;
//# sourceMappingURL=WorkflowReportNode.js.map
